import React, {useEffect} from "react";
import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {calculateRemSize, display, flex, flexDirection, mb, onDesktop, p, pl, pv} from "@pg-design/helpers-css";
import {Image} from "@pg-design/image-module";
import {Modal, useModal} from "@pg-design/modal";
import {Text} from "@pg-design/text-module";

import {useMapPublicTransportUserPreferences} from "../hooks/use_map_public_transport_user_preferences";
import {hitGtmUserMapTransportPreferencesModalEvent} from "../tracking/user_map_transport_preferences_modal_gtm_events";

const mapWithTransportPoisImg = require("../images/map_with_transport_pois.png");

export const UserMapTransportPreferencesModal = () => {
    const {modalProps, openModal, closeModal, isModalRendered} = useModal({
        onAfterOpen: () => {
            hitGtmUserMapTransportPreferencesModalEvent("view");
        },
        onAfterClose: () => {
            hitGtmUserMapTransportPreferencesModalEvent("close");
        }
    });

    const {hasUserBeenAskForPublicTransport, saveUserMapTransportChoice} = useMapPublicTransportUserPreferences();

    useEffect(() => {
        if (!hasUserBeenAskForPublicTransport) {
            openModal();
        }

        if (hasUserBeenAskForPublicTransport && isModalRendered) {
            closeModal();
        }
    }, [hasUserBeenAskForPublicTransport]);

    const onUserChoiceMapWithTransport = () => {
        saveUserMapTransportChoice(true);
        hitGtmUserMapTransportPreferencesModalEvent("railroad_map");
    };

    const onUserChoiceMapWithoutTransport = () => {
        saveUserMapTransportChoice(false);
        hitGtmUserMapTransportPreferencesModalEvent("normal_map");
    };

    return (
        <Modal {...modalProps} showCloseButton={false} css={modalContentStyle}>
            <Modal.Layout.EmptyResponsive css={[p(3), display("block")]}>
                <Text variant="headline_3" css={mb(4)}>
                    Odkrywaj inwestycje z najlepszym dostępem do komunikacji
                </Text>

                <div css={[flex("center"), flexDirection("column"), onDesktop(flex("flex-start")), onDesktop(flexDirection("row"))]}>
                    <div>
                        <Image height="260px" width="325px" src={mapWithTransportPoisImg} alt="Wybór wariantu mapy" />
                    </div>
                    <div css={textWrapperStyle}>
                        <Text variant="body_copy_0" css={mb(2)}>
                            Stworzyliśmy mapę transportową, która wskaże Ci bliskość przystanków tramwajowych oraz stacji kolejowych.
                        </Text>
                        <Text variant="body_copy_2">
                            Mapa pomoże Ci w znalezieniu idealnego M niezależnie od tego, czy szukasz mieszkania w centrum czy na obrzeżach.
                        </Text>

                        <div css={buttonsWrapperStyle}>
                            <Button variant="filled_primary" type="button" onClick={onUserChoiceMapWithTransport}>
                                Włącz mapę transportową
                            </Button>
                            <Button variant="none_secondary" type="button" onClick={onUserChoiceMapWithoutTransport}>
                                Użyj zwykłej mapy
                            </Button>
                        </div>
                    </div>
                </div>
            </Modal.Layout.EmptyResponsive>
        </Modal>
    );
};

const modalContentStyle = css`
    ${onDesktop(css`
        width: 95%;
        max-width: 96rem;
    `)};
`;

const textWrapperStyle = css`
    display: flex;
    flex-direction: column;

    ${onDesktop(css`
        ${pl(4)};
    `)};
`;

const buttonsWrapperStyle = (theme: Theme) => css`
    align-self: flex-end;
    ${pv(4)};
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: ${calculateRemSize(2)};
    width: 100%;

    @media (min-width: ${theme.breakpoints.sm}) {
        flex-direction: row;
    }

    @media (min-width: ${theme.breakpoints.md}) {
        justify-content: flex-start;
    }
`;
import React, {useEffect} from "react";
import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {calculateRemSize, display, flex, flexDirection, mb, onDesktop, p, pl, pv} from "@pg-design/helpers-css";
import {Image} from "@pg-design/image-module";
import {Modal, useModal} from "@pg-design/modal";
import {Text} from "@pg-design/text-module";

import {useMapPublicTransportUserPreferences} from "../hooks/use_map_public_transport_user_preferences";
import {hitGtmUserMapTransportPreferencesModalEvent} from "../tracking/user_map_transport_preferences_modal_gtm_events";

const mapWithTransportPoisImg = require("../images/map_with_transport_pois.png");

export const UserMapTransportPreferencesModal = () => {
    const {modalProps, openModal, closeModal, isModalRendered} = useModal({
        onAfterOpen: () => {
            hitGtmUserMapTransportPreferencesModalEvent("view");
        },
        onAfterClose: () => {
            hitGtmUserMapTransportPreferencesModalEvent("close");
        }
    });

    const {hasUserBeenAskForPublicTransport, saveUserMapTransportChoice} = useMapPublicTransportUserPreferences();

    useEffect(() => {
        if (!hasUserBeenAskForPublicTransport) {
            openModal();
        }

        if (hasUserBeenAskForPublicTransport && isModalRendered) {
            closeModal();
        }
    }, [hasUserBeenAskForPublicTransport]);

    const onUserChoiceMapWithTransport = () => {
        saveUserMapTransportChoice(true);
        hitGtmUserMapTransportPreferencesModalEvent("railroad_map");
    };

    const onUserChoiceMapWithoutTransport = () => {
        saveUserMapTransportChoice(false);
        hitGtmUserMapTransportPreferencesModalEvent("normal_map");
    };

    return (
        <Modal {...modalProps} showCloseButton={false} css={modalContentStyle}>
            <Modal.Layout.EmptyResponsive css={[p(3), display("block")]}>
                <Text variant="headline_3" css={mb(4)}>
                    Odkrywaj inwestycje z najlepszym dostępem do komunikacji
                </Text>

                <div css={[flex("center"), flexDirection("column"), onDesktop(flex("flex-start")), onDesktop(flexDirection("row"))]}>
                    <div>
                        <Image height="260px" width="325px" src={mapWithTransportPoisImg} alt="Wybór wariantu mapy" />
                    </div>
                    <div css={textWrapperStyle}>
                        <Text variant="body_copy_0" css={mb(2)}>
                            Stworzyliśmy mapę transportową, która wskaże Ci bliskość przystanków tramwajowych oraz stacji kolejowych.
                        </Text>
                        <Text variant="body_copy_2">
                            Mapa pomoże Ci w znalezieniu idealnego M niezależnie od tego, czy szukasz mieszkania w centrum czy na obrzeżach.
                        </Text>

                        <div css={buttonsWrapperStyle}>
                            <Button variant="filled_primary" type="button" onClick={onUserChoiceMapWithTransport}>
                                Włącz mapę transportową
                            </Button>
                            <Button variant="none_secondary" type="button" onClick={onUserChoiceMapWithoutTransport}>
                                Użyj zwykłej mapy
                            </Button>
                        </div>
                    </div>
                </div>
            </Modal.Layout.EmptyResponsive>
        </Modal>
    );
};

const modalContentStyle = css`
    ${onDesktop(css`
        width: 95%;
        max-width: 96rem;
    `)};
`;

const textWrapperStyle = css`
    display: flex;
    flex-direction: column;

    ${onDesktop(css`
        ${pl(4)};
    `)};
`;

const buttonsWrapperStyle = (theme: Theme) => css`
    align-self: flex-end;
    ${pv(4)};
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: ${calculateRemSize(2)};
    width: 100%;

    @media (min-width: ${theme.breakpoints.sm}) {
        flex-direction: row;
    }

    @media (min-width: ${theme.breakpoints.md}) {
        justify-content: flex-start;
    }
`;
